export const API_PREFIX = process.env.API_PREFIX;

const WS_DOMAIN_TEMPATE = 'ws.smartbotpro.io';

const isProd = process.env.NODE_ENV === 'production';

export const WS_DOMAIN = isProd ? WS_DOMAIN_TEMPATE : process.env.WS_DOMAIN;
export const WS_PATH = '/connection/websocket';

export const MESSAGES_LIMIT = 20;
